__turbopack_context__.v({
  "list": "price-breakdown-list-module-scss-module__WUkz5q__list",
  "placeholder": "price-breakdown-list-module-scss-module__WUkz5q__placeholder",
});
